/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateUpdateContractDtoSignaturePosition
 */
export interface CreateUpdateContractDtoSignaturePosition {
    /**
     * 
     * @type {number}
     * @memberof CreateUpdateContractDtoSignaturePosition
     */
    x?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateUpdateContractDtoSignaturePosition
     */
    y?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateUpdateContractDtoSignaturePosition
     */
    page?: number;
}

/**
 * Check if a given object implements the CreateUpdateContractDtoSignaturePosition interface.
 */
export function instanceOfCreateUpdateContractDtoSignaturePosition(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CreateUpdateContractDtoSignaturePositionFromJSON(json: any): CreateUpdateContractDtoSignaturePosition {
    return CreateUpdateContractDtoSignaturePositionFromJSONTyped(json, false);
}

export function CreateUpdateContractDtoSignaturePositionFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpdateContractDtoSignaturePosition {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'x': !exists(json, 'x') ? undefined : json['x'],
        'y': !exists(json, 'y') ? undefined : json['y'],
        'page': !exists(json, 'page') ? undefined : json['page'],
    };
}

export function CreateUpdateContractDtoSignaturePositionToJSON(value?: CreateUpdateContractDtoSignaturePosition | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'x': value.x,
        'y': value.y,
        'page': value.page,
    };
}

